// Theme resolution is per-request (host based), NOT per-build.
//
// Brand (VARIANT) and theme are two different axes:
//   - VARIANT (build time)  -> feature config, logo, API paths, auth cookie, i18n default locale
//   - theme  (per request)  -> palette only
//
// A sub-brand like heya.flyin.com is a FLYIN build — same image, same deploy, same
// market maps as eg.flyin.com — that only paints itself with a different palette.
// Keep this file free of `next/headers` and node built-ins: it is imported by both
// the server layout and the client ThemeProvider.

export type ThemeKey = 'flyin' | 'cleartrip' | 'heya'

// Sub-brand hosts. Anything not listed falls back to the build's brand theme, so
// adding a host here is the only step needed to give it a palette.
const HOST_THEME_MAP: Record<string, ThemeKey> = {
    // 'localhost': 'heya',
    // 'heya.flyin.com': 'heya',
    'me-heya.flyin.com': 'heya'
}

/** The theme a build defaults to when the host has no sub-brand entry. */
export const getBrandThemeKey = (): ThemeKey =>
    process.env.NEXT_PUBLIC_VARIANT === 'CLEARTRIP' ? 'cleartrip' : 'flyin'

/**
 * @param host raw `host` header or `window.location.host` — port and case are tolerated.
 */
export const resolveThemeKey = (host?: string | null): ThemeKey => {
    const hostname = (host || '').toLowerCase().split(':')[0]
    return HOST_THEME_MAP[hostname] || getBrandThemeKey()
}

/** For code that already holds a host string. Otherwise use useIsHeya()/isHeyaServer(). */
export const isHeyaHost = (host?: string | null): boolean => resolveThemeKey(host) === 'heya'
